import { render, staticRenderFns } from "./responsiblePersonsAdd.vue?vue&type=template&id=bf7d90d2&scoped=true&"
import script from "./responsiblePersonsAdd.vue?vue&type=script&lang=js&"
export * from "./responsiblePersonsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7d90d2",
  null
  
)

export default component.exports